import React from "react";

export const DeliveryDetailContext = React.createContext(null);

export const useDeliveryDetailContext = () => {
  const context = React.useContext(DeliveryDetailContext);

  if (!context)
    throw new Error("Delivery Detail Context not provided!");

  return context;
};
